import React, { useContext } from "react";
import { Modal } from "antd";
import { ThemeContext } from "../../common/themeContext";


const SwitchModal = ({ show, onYes, onNo, onOkOnly, title, message }) => {
  const { theme } = useContext(ThemeContext);

  return (
    <Modal
      className={theme === "healthCare" ? "healthcare mx550" : "primecare mx550"}
      open={show}
      onCancel={onNo}
      onOk={onOkOnly ? onYes : onNo} // onOk is triggered when the user clicks the primary button in the modal footer. For onOkOnly, 'Yes' acts as 'Ok'. Otherwise, 'No' acts as 'Ok' by closing the modal.
      footer={onOkOnly ? [
        <button key="ok" className="okbtn continuebtn" onClick={onYes}>
          Okay
        </button>,
      ] : [
        <button
          key="cancel"
          className="py3 fw-18 gbo continuebtn savebtn cancelbtn me-20"
          onClick={onNo}
        >
          Cancel
        </button>,
        <button key="yes" className="okbtn continuebtn" onClick={onYes}>
          Yes, Switch 
        </button>,
      ]}
    >
      <div className="mb-2 heedprodct text-center mt-3">
        {title || "Switch Active Template?"}
      </div>
      <div className="sc text-center mb-4">
        {message ||
          "Only one template can be active at a time. Activating this template will replace your current selection. Do you want to continue?"}
      </div>
    </Modal>
  );
};

export default SwitchModal;
